import React, { useEffect, useState } from "react";
import { cn } from "../../../../lib/utils";
import renew from "../../../../assets/icons/Renew.svg";
import Reregister from "../../../../assets/icons/Re-Register.svg";
import Axios from "../../../../services/Axios";
import APIVariables from "../../../../services/api-variables";
import { handleCatch } from "../../../../shared/helpers";
import DrugRegistrationModal from "./DrugRegistrationModal";
import moment from "moment";
import { registrationCategory } from "../../../../constants/register.constants";

export const DrugRegistration = ({ profileDetails, getProfileData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [productID, setProductID] = useState([]);
  const [productConfirmations, setProductConfirmations] = useState([]);
  const [checkboxesMedications, setCheckboxeslMedications] = useState([]);
  const [isregistering, setIsregistering] = useState(false);
  const [wasLinkClicked, setWasLinkClicked] = useState(false);
  const [confirmInformationGuideRead, setConfirmInformationGuideRead] =
    useState(false);
  const [openGuideRead, setOpenGuideRead] = useState(false);

  const products = profileDetails.products;
  const user_type =
    profileDetails.user_type === registrationCategory.PRESCRIBER
      ? 1
      : (profileDetails.user_type === registrationCategory.PHARMACY ||
        profileDetails.user_type ===
        registrationCategory.CONNECTED_HOMECARE ||
        profileDetails.user_type ===
        registrationCategory.CONNECTED_OUTPATIENT) &&
      2;

  const getProductConfirmation = async (productID) => {
    await Axios.get(APIVariables.GETCONF + `/${user_type}/${productID}`)
      .then((res) => {
        const { status, data } = res;
        if (status === 200) {
          setProductConfirmations(data);
        }
      })
      .catch((error) => {
        handleCatch(error);
      });
  };

  const handleCheckboxes = (key) => {
    const numericKey = Number(key); // Convert key to a number dynamically
    if (checkboxesMedications.includes(numericKey)) {
      // Key exists, remove it from the array
      setCheckboxeslMedications(
        checkboxesMedications.filter((id) => id !== numericKey)
      );
    } else {
      // Key does not exist, add it to the array
      setCheckboxeslMedications([...checkboxesMedications, numericKey]);
    }
  };
  // Check if the number of checkboxes is equal to the number of checked checkboxes
  const lengths = Object.keys(productConfirmations).length;
  const isValid = checkboxesMedications?.length === lengths;

  const brochureNull = productConfirmations.filter((element) => {
    return (
      element.brochure_id !== null &&
      element.confirmation_name.includes("<brochure>")
    );
  });
  const registerProduct = async () => {
    setIsregistering(true);
    if (
      isValid === true &&
      (brochureNull.length !== 0 ? wasLinkClicked : true)
    ) {
      setOpenGuideRead(true);
    }
    if (openGuideRead === true) {
      // Check if confirmInformationGuideRead is true when OpenGuideRead is true
      if (confirmInformationGuideRead === true) {
        const res = await Axios.post(APIVariables.REGISTER_PRODUCT, {
          user_type: user_type,
          product: productID,
          confirmations: checkboxesMedications,
        }).catch((error) => {
          handleCatch(error);
        });

        if (res?.status === 200 && res?.data?.detail === "success") {
          setOpenGuideRead(false);
          setIsOpen(false);
          getProfileData();
          setCheckboxeslMedications([]);
          setIsregistering(false);
          setConfirmInformationGuideRead(false);
          setProductConfirmations([]);
          setWasLinkClicked(false);
        }
      }
    }
  };

  const handleCheckConfirmInformationGuideRead = (event) => {
    setConfirmInformationGuideRead(event.target.checked);
  };

  const closeModalGuideRead = (event) => {
    if (event.key === "Escape") {
      return;
    }
    setOpenGuideRead(false);
    registerProduct();
  };

  const clearData = () => {
    setCheckboxeslMedications([]);
    setProductConfirmations([]);
    setIsregistering(false);
    setWasLinkClicked(false);
  };

  // When you are registered/renew for a product localstorage is updated
  const existingData = JSON.parse(localStorage.getItem("USER_NHSPORTAL")) || {};

  existingData.products = profileDetails?.products;

  useEffect(() => {
    localStorage.setItem("USER_NHSPORTAL", JSON.stringify(existingData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingData.products]);

  return (
    <div
      className="mx-auto mt-3 w-full max-w-[1100px] rounded-lg bg-white px-6 py-5 shadow-xl sm:px-10"
      data-testid="profile-drug-registration"
    >
      <h2 className="mb-4 text-lg font-semibold text-[#00567a]" data-testid="profile-drug-registration-heading">
        Drug Registration Details
      </h2>
      <div className="overflow-x-auto">
        <table
          className="w-full table-fixed border-collapse text-sm md:text-base"
          data-testid="profile-drug-registration-table"
        >
          <thead>
            <tr className="h-14">
              <th className="w-[34%] border border-neutral-300 bg-neutral-50 p-2 font-normal" />
              <th data-testid="profile-drug-registration-table-header-registration-valid-until" className="w-[33%] border border-neutral-300 bg-neutral-50 p-2 font-semibold text-[#00567a]">
                Registration Valid Until
              </th>
              <th className="w-[33%] border border-neutral-300 bg-neutral-50 p-2 font-normal" />
            </tr>
          </thead>
          <tbody>
            {products?.map((prod) => (
              <tr
                key={prod.product_id}
                className="h-[60px]"
                data-testid={`profile-drug-row-${prod.product_id}`}
              >
                <td
                  className={cn(
                    "border border-neutral-300 p-2 align-middle text-white",
                    prod.product_active === false
                      ? "cursor-not-allowed bg-neutral-400"
                      : "bg-[#00567A]"
                  )}
                >
                  {prod.product_name}
                </td>
                <td className="border border-neutral-300 p-2 align-middle text-neutral-900 text-center">
                  <p className="m-0">
                    {prod.expiry_date === null
                      ? " - "
                      : moment(prod.expiry_date).format("DD / MM / YYYY")}
                  </p>
                </td>
                <td className="border border-neutral-300 p-2 align-middle text-center">
                  <div className="flex min-h-[44px] items-center justify-center">
                    {prod.product_active === false ? (
                      <span className="mx-auto max-w-[185px] text-[#fb3449]">
                        This drug is currently disabled
                      </span>
                    ) : prod.pending_activation === true &&
                      prod.product_active === true ? (
                      <p className="m-0 max-w-[185px] text-[#fb3449]">
                        Medication disabled for you
                      </p>
                    ) : (
                      (() => {
                        const openModal = () => {
                          setProductID(prod.product_id);
                          getProductConfirmation(prod.product_id);
                          setIsOpen(true);
                        };
                        if (prod.can_renew_registration === true) {
                          return (
                            <button
                              type="button"
                              className="border-0 bg-transparent p-0"
                              onClick={openModal}
                              data-testid={`profile-drug-renew-${prod.product_id}`}
                            >
                              <img src={renew} alt="Renew registration" />
                            </button>
                          );
                        }
                        if (
                          prod.can_register === true &&
                          prod.product_active === true
                        ) {
                          return (
                            <button
                              type="button"
                              className="inline-flex h-[38px] w-32 items-center justify-center rounded-full bg-[#00567A] text-sm font-semibold text-white"
                              onClick={openModal}
                              data-testid={`profile-drug-register-${prod.product_id}`}
                            >
                              Register
                            </button>
                          );
                        }
                        if (prod.can_re_register === true) {
                          return (
                            <button
                              type="button"
                              className="border-0 bg-transparent p-0"
                              onClick={openModal}
                              data-testid={`profile-drug-reregister-${prod.product_id}`}
                            >
                              <img src={Reregister} alt="Re-register" />
                            </button>
                          );
                        }
                        return null;
                      })()
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DrugRegistrationModal
        isOpen={isOpen}
        handleCheckboxes={handleCheckboxes}
        registerProduct={registerProduct}
        profileDetails={profileDetails}
        products={products}
        checkboxesMedications={checkboxesMedications}
        user_type={user_type}
        productID={productID}
        productConfirmations={productConfirmations}
        setCheckboxeslMedications={setCheckboxeslMedications}
        setProductConfirmations={setProductConfirmations}
        isValid={isValid}
        isregistering={isregistering}
        setIsregistering={setIsregistering}
        setWasLinkClicked={setWasLinkClicked}
        wasLinkClicked={wasLinkClicked}
        onRequestClose={() => setIsOpen(false)}
        clearData={clearData}
        brochureNull={brochureNull}
        openGuideRead={openGuideRead}
        closeModalGuideRead={closeModalGuideRead}
        confirmInformationGuideRead={confirmInformationGuideRead}
        handleCheckConfirmInformationGuideRead={
          handleCheckConfirmInformationGuideRead
        }
      />
    </div>
  );
};
